import { PM_COMPONENTS_OPT, OUTFORZ_STATUS_OPT } from "../../../config/const";

const yesNo = row => (row.price_monitoring ? "✓" : "—");

export default {
  slug: "categories",
  endpoint: "categories_point/",
  titleKey: "categories_title",
  subtitleKey: "categories_sub",
  columns: [
    { field: "name", label: "f_name" },
    { label: "f_price_monitoring", format: yesNo },
  ],
  fields: [
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "price_monitoring", type: "checkbox", label: "f_price_monitoring" },
    { name: "price_monitoring_components", type: "chips", label: "f_pm_components", options: PM_COMPONENTS_OPT },
    { name: "price_monitoring_required_components", type: "chips", label: "f_pm_required", options: PM_COMPONENTS_OPT },
    { name: "send_to_outforz", type: "checkbox", label: "f_send_outforz" },
    { name: "is_auto_approve_price_monitoring_reports", type: "checkbox", label: "f_auto_approve" },
    { name: "status_to_send_to_outforz", type: "select", label: "f_status_outforz", options: OUTFORZ_STATUS_OPT },
    { name: "default_tags", type: "entity", entity: "tags", isMulti: true, label: "f_default_tags", wide: true },
  ],
  /* Grouped rather than a flat 3-column grid: the checkboxes and their dependent multi-selects read
     as scattered otherwise. Price-monitoring config together, the Outforz integration together. */
  sections: [
    { title: "sec_basic", fields: ["name", "default_tags"] },
    {
      title: "sec_price_monitoring",
      fields: ["price_monitoring", "price_monitoring_components", "price_monitoring_required_components", "is_auto_approve_price_monitoring_reports"],
    },
    { title: "sec_integration", fields: ["send_to_outforz", "status_to_send_to_outforz"] },
  ],
  injectOnCreate: (item, me) => ({ ...item, company: me && me.company ? me.company.id : null }),
  /* ⚠ Depends on the picsell-api change that makes `Category` a `SoftDeletableModel` (migration
     0052) — before it, DELETE on a category was a HARD delete: the row was destroyed, and
     `Point.category` being SET_NULL meant every point silently lost its category. Migration 0051
     gave the other four reference models `is_removed` and skipped this one. */
  softDelete: true,
};
